interface NetworkInformation {
    saveData: boolean;
}

export function isSaveDataEnabled(): boolean {
    try {
        if ('connection' in navigator) {
            console.debug('connection exists in navigator');
            const isSavingData = (navigator as Navigator & { connection: NetworkInformation }).connection.saveData;
            if (isSavingData) {
                console.log('Saving data is enabled');
                return true;
            }
        }
    } catch (err) {
        console.error('Failed to check if saving data is enabled:', err);
    }
    return false;
}